/**
 * trackAccess  –  método global para registar um acesso a um módulo.
 *
 * Uso dentro de um componente React (recomendado):
 *   const { trackAccess } = useAnalytics();
 *   useEffect(() => { trackAccess('Beacon4Performance', 'Beacon4 Performance', userId); }, []);
 *
 * Uso fora de componentes (router guard, init script, etc.):
 *   import trackAccess from 'src/views/AnalyticsDashboard/trackAccess';
 *   trackAccess('Beacon4Performance', 'Beacon4 Performance', userId);
 */

import { PostTrackAccess } from './requests/analyticsRequests';

const trackAccess = async (moduleId, moduleName, userId) => {
	try {
		await PostTrackAccess(moduleId, moduleName, userId);
	} catch {
		// fail silently – tracking should never break the app
	}
};

export default trackAccess;